import { render, staticRenderFns } from "./EntregaAtualizarValorHora.vue?vue&type=template&id=13a31cc4"
import script from "./EntregaAtualizarValorHora.vue?vue&type=script&lang=js"
export * from "./EntregaAtualizarValorHora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports